module.exports = __webpack_public_path__ + "img/Entia-Infraestructura-Ferroviaria-6.bfd696e9.webp";